import $ from "jquery";
import videojs from "video.js";
import bdjs from "@bd-core/bdjs";
import bdapi from "@bd-core/bd-api";
import CONFIG from "@bd-core/config";
import Storage from "@bd-utils/storage";
import GameLogic from "@bd-core/game-logic";
import BD_Component from "../core/bd-component";
import compile from "../utils/handlerbars-helper";
import Screen from "@bd-utils/screen";
import {
    getFinalRoomAnswers,
    maybeUpdateRoomStatus,
    setEmailPhishingAction,
    setGameFinished,
    setRoomTotalScores,
    setTeamLogos,
    updateCurrentScreen,
    updateFinalRoomAnswer,
} from "@bd-core/firebase-actions";
import {
    getCurrentRoomScreen,
    getEmailPhishingAction,
    getFinalTeamAnswers,
    getLeader,
    getRoomLogo,
    getRoomScore,
    getRoomStatus,
} from "@bd-stores/game-progress";
import { getRoomAnswerById } from "@bd-stores/game-data";
import { getState } from "@bd-stores/store";
import { isLeader } from "@bd-stores/game-progress";
import { isTestMode } from "@bd-utils/test-mode";

export class RoomEndGame extends BD_Component {
    constructor() {
        super();

        this.id = "end_game";
        this.templateID = "end_game-template";

        this.elms = {
            // narrative popup
            narrativePopup: ".js-narrative-popup",
            narrativeCloseBtn: ".js-close-narrative-popup",

            // reward screen
            rewardScreen: ".js-reward-feedback",
            rewardTitle: ".js-reward-title",
            rewardSubtitle: ".js-reward-subtitle",
            rewardDescription: ".js-reward-description",
            rewardScore: ".js-reward-score",
            rewardContinueBtn: ".js-reward-continue-btn",
            triggerRewardScreenBtn: ".btn-continue-reward-screen",

            // customization
            customizationScreen: ".js-customization",
            customRewardWrapper: ".challange-prize__item-wrapper",
            customizationContinueBtn: ".js-customization-continue-btn",
            customizationCategory: ".js-category",
            logoImage: ".js-logo",

            // puzzle
            puzzlePartOneBtn: ".js-puzzle-part-1-btn",
            puzzlePartTwoBtn: ".js-puzzle-part-2-btn",
            puzzlePartOneScreen: ".js-puzzle-part-1",
            puzzlePartTwoScreen: ".js-puzzle-part-2",
            finishScreenPartOne: ".js-finish-part-1",
            questionItem: ".js-question",
            checkBtn: ".js-submit",
            crystalEarned: ".js-crystal-earned",
            continueBtn: ".js-continue",
            nextQuestionBtn: ".js-next-question",
            checkBox: ".js-checkbox", // image with checkboxes
            inputAnswer: ".js-input-answer", // image with input
            selectAnswer: ".js-select-answer", // multiple questions
            orderImage: ".js-image-for-order", // image in order
            imageToOrder: ".js-image-for-order",
            imageOrderNumber: ".js-order-number",
            resetOrder: ".js-reset-order",
            orderingQuiz: ".js-ordering-quiz",
            turnOnFinishPartBtn: ".js-turned-one-finished-part",
            phishingEmailPopup: ".js-phishing-popup",
            reportPhishingBtn: ".js-report-email",
            phishingBtn: ".js-phishing-btn",
            closePhishingBtn: ".js-close-email",
            phishingActionBtn: ".js-phishing-action",
            closeIntroPartTwo: ".js-close-info-button-part-two",

            skipVideoBtn: ".js-skip-video"
        };

        this._events = this.getEvents();

        this._data = {};

        this.teamName = CONFIG.game.teamname;

        this.playerEmail = CONFIG.user.email;

        this.clickCount = 0;

        this.meSubmitting = false;

        this.partTwoBgAudio = null;
    }

    /**
     * @returns {Array<BD_ComponentEvent>}
     */
    getEvents() {
        const elms = this.elms;
        return [
            {
                event: "click",
                selector: elms.checkBox,
                handler: this.handleImageWithCheckboxes,
            },
            {
                event: "click",
                selector: elms.selectAnswer,
                handler: this.handleSelectAnswer,
            },
            {
                event: "click",
                selector: elms.checkBtn,
                handler: this.onCheckAnswer,
            },
            {
                event: "click",
                selector: elms.puzzlePartOneBtn,
                handler: this.goToPuzzlePartOne,
            },
            {
                event: "click",
                selector: elms.puzzlePartTwoBtn,
                handler: this.goToPuzzlePartTwo,
            },
            {
                event: "click",
                selector: elms.nextQuestionBtn,
                handler: this.getNextQuestion,
            },
            {
                event: "click",
                selector: elms.orderImage,
                handler: this.onOrderImage,
            },
            {
                event: "click",
                selector: elms.resetOrder,
                handler: this.onResetOrder,
            },
            {
                event: "input",
                selector: elms.inputAnswer,
                handler: this.handleInputAnswer,
            },
            {
                event: "click",
                selector: elms.continueBtn,
                handler: this.getNextQuestion,
            },
            {
                event: "click",
                selector: elms.rewardContinueBtn,
                handler: this.goToCustomizationScreen,
            },
            {
                event: "click",
                selector: elms.customizationContinueBtn,
                handler: this.setSelectedLogo,
            },
            {
                event: "click",
                selector: elms.narrativeCloseBtn,
                handler: this.closeNarrativePopup,
            },
            {
                event: "click",
                selector: elms.turnOnFinishPartBtn,
                handler: this.handleFinishedPart,
            },
            {
                event: "click",
                selector: `${elms.reportPhishingBtn}, ${elms.closePhishingBtn}, ${elms.phishingBtn}`,
                handler: this.onClosePhishingEmail,
            },
            {
                event: "click",
                selector: elms.closeIntroPartTwo,
                handler: this.closeIntroPartTwo,
            },
            {
                event: "click",
                selector: elms.triggerRewardScreenBtn,
                handler: this.playOutroVideo,
            },
            {
                event: "click",
                selector: elms.skipVideoBtn,
                handler: this.skipOutroVideo
            }
        ];
    }

    beforeInit() {
        window.screenCalculationFunc = () => Screen.calculateCoverSize();
        this.render();
        this.setGameState();
        this.setupSlider();
        this.setTestMode();
    }

    setModifiedData() {
        const roomData = this._data;
        const { email_phishing } = roomData;
        const { subject, body } = email_phishing;
        const $theButton = `<button class="phishing-email__email-button js-phishing-action js-phishing-btn" data-action="click_button">Claim extra seconds!</button>`;
        const team_name = this.teamName;
        const modifiedSubject = subject.replaceAll("{team_name}", team_name);
        let modifiedBody = body.replaceAll("{team_name}", team_name);
        modifiedBody = modifiedBody.replaceAll("{the_button}", $theButton);

        const modifiedEmailTxt = {
            ...email_phishing,
            subject: modifiedSubject,
            body: modifiedBody,
            recipient_email: this.playerEmail,
        };

        const modifiedData = {
            ...roomData,
            isLeader: isLeader(),
            team_name: team_name,
            email_phishing: modifiedEmailTxt,
        };

        return modifiedData;
    }

    render() {
        const modifiedData = this.setModifiedData();
        const htmlTemplate = $("#" + this.templateID).html();
        const html = compile(htmlTemplate, modifiedData);
        $(".app").html(html);
        window.screenCalculationFunc = () => Screen.calculateCoverSize();
    }

    setTestMode() {
        if (isTestMode()) {
            // $(this.elms.continueBtn).removeClass("hidden disabled");
            $(".app__back").removeClass("hidden");
        }
    }

    setGameState() {
        const elms = this.elms;
        const roomId = this.roomId;
        const roomAnswers = getFinalTeamAnswers(roomId);
        const currentStatus = getRoomStatus(roomId);
        const isRoomCompleted = currentStatus === "is-status-completed";
        const $continueBtn = $(elms.continueBtn);
        const $partOne = $(elms.puzzlePartOneScreen);
        const isOpened = $partOne
            .find(".endgame-part-bg")
            .hasClass("turned-on");
        const is_leader = isLeader();

        if (is_leader) {
            const $sourceBtn = $(".js-sources-button");
            $sourceBtn.addClass("hidden");
        }

        if (is_leader && isRoomCompleted) {
            $continueBtn.removeClass("hidden disabled");
        }

        if (!this.meSubmitting) {
            if (Object.keys(roomAnswers).length > 0) {
                $.each(roomAnswers, function (index, item) {
                    const questionId = String(index);
                    const $theQuestion = $(
                        `${elms.questionItem}[data-id="${questionId}"]`,
                    );
                    const questionType = $theQuestion.attr("data-type");

                    $theQuestion.addClass("quiz-answered");

                    if (questionType === "multiple_questions") {
                        const { answer, status } = item;

                        if (status === "correct") {
                            $(
                                `${elms.selectAnswer}[data-id="${answer}"]`,
                            ).addClass("selected correct");
                        } else {
                            $(
                                `${elms.selectAnswer}[data-id="${answer}"]`,
                            ).addClass("selected wrong");
                        }

                        $partOne.find(".endgame-part-bg").addClass(status);
                        if (isOpened)
                            $continueBtn.removeClass("hidden disabled");
                    } else if (questionType === "image_in_order") {
                        let wrongTotal = 0;

                        $.each(item, function (index, answerData) {
                            const { answer, status } = answerData;
                            const $image = $(
                                `${elms.imageToOrder}[data-id="${answer}"]`,
                            );
                            $image
                                .addClass(`${status} .selected`)
                                .attr("data-order", index + 1);
                            $image.append(
                                `<span class="order-number">${
                                    index + 1
                                }</span>`,
                            );

                            if (status === "wrong") wrongTotal++;
                        });

                        const answerStatus =
                            wrongTotal > 0 ? "wrong" : "correct";
                        $partOne
                            .find(".endgame-part-bg")
                            .addClass(answerStatus);
                        if (isOpened)
                            $continueBtn.removeClass("hidden disabled");
                    } else if (questionType === "image_with_checkboxes") {
                        let wrongTotal = 0;

                        $.each(item, function (index, answerData) {
                            const { answer, status } = answerData;
                            const $checkbox = $(
                                `${elms.checkBox}[data-id="${answer}"]`,
                            );
                            $checkbox
                                .addClass(`${status} selected`)
                                .prop("checked", true);

                            if (status === "wrong") wrongTotal++;
                        });

                        const answerStatus =
                            wrongTotal > 0 ? "wrong" : "correct";
                        $partOne
                            .find(".endgame-part-bg")
                            .addClass(answerStatus);
                        if (isOpened)
                            $continueBtn.removeClass("hidden disabled");
                    } else if (questionType === "image_with_input_fields") {
                        let wrongTotal = 0;

                        $.each(item, function (index, answerData) {
                            const { answer, status } = answerData;
                            const answerId = String(index);

                            const $input = $(
                                `${elms.inputAnswer}[data-id="${answerId}"]`,
                            );
                            $input
                                .val(answer)
                                .addClass(status)
                                .prop("disabled", true);

                            if (status === "wrong") wrongTotal++;
                        });

                        const answerStatus =
                            wrongTotal > 0 ? "wrong" : "correct";
                        $partOne
                            .find(".endgame-part-bg")
                            .addClass(answerStatus);
                        if (isOpened)
                            $continueBtn.removeClass("hidden disabled");
                    }
                });
            }
        }

        /* force players to be on the same screen */
        const currentScreen = getCurrentRoomScreen(roomId);
        const video = videojs.getPlayer("outro-video-end-game");

        switch (currentScreen) {
            case "search-find":
                $(".narrative-layer").show();
                $(".search-and-find-bg").show();
                break;
            case "video-outro":
                this.playOutroVideo();
                break;
            case "reward-screen":
                if ((video && video.ended()) || (video && video.paused())) {
                    this.goToRewardScreen();
                }
                break;
            case "customisations-screen":
                this.goToCustomizationScreen();
                break;
            case "puzzle-screen":
                if (is_leader) {
                    $(".narrative-layer").hide();
                    $(".search-and-find-bg").hide();
                    $(".videobox").removeClass("is-open");
                    $(elms.rewardScreen).removeClass("active");
                    $(elms.customizationScreen).removeClass("active");
                }
                break;
            default:
            //
        }
        /* END: force players to be on the same screen */

        /* email phishing popup */
        const phishingAction = getEmailPhishingAction();

        if (phishingAction) {
            const $phishingActionBtns = $(elms.phishingActionBtn).not(
                `[data-action=${phishingAction}]`,
            );

            $phishingActionBtns.prop("disabled", true);
        }
        /* END email phishing popup */
    }

    goToPuzzlePartOne(e, $el) {
        e.preventDefault();

        const is_leader = isLeader();
        if (!is_leader) {
            GameLogic.toggleBriefing();
            GameLogic.toggleSourcesPopup();
            return;
        }
        const elms = this.elms;
        const $continueBtn = $(elms.continueBtn);
        const $theQuestion = $el
            .parents(".endgame-part")
            .find(elms.questionItem)
            .first();
        const isAnswered = $theQuestion.hasClass("quiz-answered");
        const roomId = this.roomId;
        const currentStatus = getRoomStatus(roomId);
        const isRoomCompleted = currentStatus === "is-status-completed";

        $el.parent().fadeOut();
        $el.parents(elms.puzzlePartOneScreen)
            .find(".endgame-part-bg")
            .addClass("turned-on");
        $el.parents(elms.puzzlePartOneScreen)
            .find(".endgame-part-content")
            .fadeIn();
        $el.parents(elms.puzzlePartOneScreen)
            .find(elms.questionItem)
            .first()
            .show();

        setTimeout(() => {
            $theQuestion.addClass("part-1-active active");

            if (isAnswered || isRoomCompleted)
                $continueBtn.removeClass("hidden disabled");
        }, 600);

        setTimeout(() => {
            GameLogic.toggleBriefing();
        }, 500);

        updateCurrentScreen(this.roomId, "puzzle-screen");
    }

    showPopupInfoAfterPhishing(popupData) {
        const elms = this.elms;
        const $narrativePopup = $(elms.narrativePopup);
        const { title, subtitle, description } = popupData;
        const $popupTitle = $narrativePopup.find("#popupTitle");
        const $popupSubtitle = $narrativePopup.find("#popupSubtitle");
        const $popupDescription = $narrativePopup.find(
            ".js-completion-popup-text",
        );

        $popupTitle.html(title);
        $popupSubtitle.html(subtitle);
        $popupDescription.html(description);
        $narrativePopup.addClass("is-open js-popup-after-phishing");
    }

    onClosePhishingEmail(e, $el) {
        const roomId = this.roomId;
        const elms = this.elms;
        const $phishingScreen = $(elms.phishingEmailPopup);

        const { crystal_impact } = this._data;
        const action = $el.attr("data-action");
        const crystal = 0;
        // @ts-ignore
        const the_crystal = crystal_impact.find(
            (item) => item.action === action,
        );
        const newCrystal = Number(the_crystal?.total_crystal) || crystal;
        const roomScore = getRoomScore(roomId);
        const updatedRoomScore = roomScore + newCrystal;

        $phishingScreen.removeClass("active");

        setEmailPhishingAction(roomId, action);
        setRoomTotalScores(roomId, updatedRoomScore);
        this.showPopupInfoAfterPhishing(the_crystal?.popup_info);
    }

    closeIntroPartTwo() {
        const $introPopupPartTwo = $(".js-info-popup-part-two");
        $introPopupPartTwo.removeClass("active");
    }

    closePuzzlePartOne() {
        const elms = this.elms;
        const $puzzlePartOne = $(elms.puzzlePartOneScreen);
        const $questionsPartOne = $puzzlePartOne.find(
            `${elms.questionItem}[data-part="1"]`,
        );
        const $finishScreen = $(elms.finishScreenPartOne);
        const $continueBtn = $(elms.continueBtn);

        $puzzlePartOne.find(".endgame-part-bg").removeClass("turned-on");
        $puzzlePartOne.find(".endgame-part-content").fadeOut();
        $questionsPartOne.removeClass("part-1-active active");
        $finishScreen.addClass("active");
        $continueBtn.addClass("hidden disabled");

        $(".finished-part").addClass("active");
    }

    goToPuzzlePartTwo(e, $el) {
        e.preventDefault();

        const is_leader = isLeader();
        if (!is_leader) return;

        const elms = this.elms;
        const bg_audio = $("#partTwoBgAudio").attr("src");
        const $continueBtn = $(elms.continueBtn);
        const $parent = $el.parents(".js-puzzle-part-2");
        const $theQuestion = $parent.find(this.elms.questionItem).first();
        const roomId = this.roomId;
        const currentStatus = getRoomStatus(roomId);
        const isRoomCompleted = currentStatus === "is-status-completed";

        $parent.find(".cockpit-zoom").addClass("active");
        $parent.find(".endgame-quiz").addClass("active");
        $theQuestion.show();

        if (bg_audio) {
            this.partTwoBgAudio = new Audio(bg_audio);
            this.partTwoBgAudio.play();
        }

        setTimeout(() => {
            $theQuestion.addClass("part-1-active active");
            const isAnswered = $theQuestion.hasClass("quiz-answered");

            if (isAnswered || isRoomCompleted)
                $continueBtn.removeClass("hidden disabled");
        }, 600);
    }

    handleFinishedPart(e, $el) {
        e.preventDefault();

        $el.parent().fadeOut();
        const elms = this.elms;
        const $finishedPartEl = $el.parents(".finished-part");
        const $puzzlePartTwo = $(elms.puzzlePartTwoScreen);

        $puzzlePartTwo.addClass("active");
        $finishedPartEl.find(".finished-part-bg").addClass("turned-on");

        setTimeout(() => {
            $(".phishing-email").addClass("active");
        }, 500);

        setTimeout(() => {
            $finishedPartEl.addClass("hidden-view");
        }, 1000);
    }

    closePuzzlePartTwo() {
        if (!this.partTwoBgAudio.paused) {
            this.partTwoBgAudio.pause();
        }

        this.maybeRoomIsFinish.call(this);
        // this.playOutroVideo();
    }

    getNextQuestion(e, $el) {
        const self = this;
        const elms = self.elms;
        const $question = $(`${elms.questionItem}.active`);
        const puzzlePart = $question.attr("data-part");
        const roomId = this.roomId;
        const currentStatus = getRoomStatus(roomId);
        const isRoomCompleted = currentStatus === "is-status-completed";

        if (isRoomCompleted) {
            return this.playOutroVideo();
        }

        $question.removeClass("part-1-active active");

        if ($question.is(":last-child")) {
            $el.parents("endgame-part").fadeOut();

            if (puzzlePart == "1") {
                this.closePuzzlePartOne();
            } else {
                this.closePuzzlePartTwo();
            }
        } else {
            const $nextQuestionItem = $question.next().css("display", "flex");
            const isNextQuestionAnswered =
                $nextQuestionItem.hasClass("quiz-answered");

            $question.fadeOut(function () {
                $nextQuestionItem.fadeIn().addClass("part-1-active active");

                if (!isNextQuestionAnswered) {
                    $(elms.puzzlePartOneScreen)
                        .find(".endgame-part-bg")
                        .removeClass("correct wrong");
                    $(elms.continueBtn).addClass("disabled hidden");
                }

                if (isRoomCompleted) {
                    $(elms.continueBtn).removeClass("disabled hidden");
                }
            });
        }
    }

    /* multiple qustions */
    handleSelectAnswer(e, $el) {
        const elms = this.elms;
        const $question = $el.parents(elms.questionItem);
        const $selection = $question.find(elms.selectAnswer);
        const $checkBtn = $(elms.checkBtn);
        const isAnswered = $question.hasClass("quiz-answered");
        const roomId = this.roomId;
        const currentStatus = getRoomStatus(roomId);
        const isRoomCompleted = currentStatus === "is-status-completed";
        if (isAnswered || isRoomCompleted) return;

        $selection.removeClass("selected");
        $el.addClass("selected");
        $checkBtn.removeClass("hidden disabled");
    }

    /* image with input fields */
    handleInputAnswer(e, $el) {
        e.preventDefault();

        const elms = this.elms;
        const $theParent = $el.parent();
        const $theQuestion = $theParent.parents(elms.questionItem);
        const isAnswered = $theQuestion.hasClass("quiz-answered");
        const roomId = this.roomId;
        const currentStatus = getRoomStatus(roomId);
        const isRoomCompleted = currentStatus === "is-status-completed";
        if (isAnswered || isRoomCompleted) return;

        const $inputs = $theParent.find(elms.inputAnswer);
        const $checkBtn = $(elms.checkBtn);
        let isAllAnswered = true;

        $.each($inputs, function (index, item) {
            const value = String($(item).val()).trim();

            if (value === "") return (isAllAnswered = false);
        });

        $checkBtn.toggleClass("disabled hidden", !isAllAnswered);
    }

    /* image in order */
    onOrderImage(e, $el) {
        e.preventDefault();

        const elms = this.elms;
        const $theQuestion = $el.parents(elms.questionItem);
        const isAnswered = $theQuestion.hasClass("quiz-answered");
        const roomId = this.roomId;
        const currentStatus = getRoomStatus(roomId);
        const isRoomCompleted = currentStatus === "is-status-completed";

        if (isAnswered || isRoomCompleted) return;

        if (!$el.hasClass("selected")) {
            this.clickCount = this.clickCount + 1;

            $el.addClass("selected");
            $el.append(
                `<span class="order-number js-order-number">${this.clickCount}</span>`,
            );
            $el.attr("data-order", this.clickCount);

            const total = $el.parents(elms.orderingQuiz).find("ul li").length;
            const $resetBtn = $el
                .parents(elms.questionItem)
                .find(elms.resetOrder);
            const $checkBtn = $(elms.checkBtn);

            if (this.clickCount >= 1) $resetBtn.removeClass("disabled");

            if (this.clickCount === total)
                $checkBtn.removeClass("disabled hidden");
        }
    }

    onResetOrder(e, $el) {
        e.preventDefault();

        this.clickCount = 0;
        const elms = this.elms;
        const $theQuestion = $el.parents(elms.questionItem);
        const isAnswered = $theQuestion.hasClass("quiz-answered");
        const roomId = this.roomId;
        const currentStatus = getRoomStatus(roomId);
        const isRoomCompleted = currentStatus === "is-status-completed";
        if (isAnswered || isRoomCompleted) return;

        $el.parents(elms.questionItem)
            .find(elms.imageToOrder)
            .removeAttr("data-order")
            .removeClass("selected correct wrong");

        $theQuestion.find(elms.imageOrderNumber).remove();
        $(elms.checkBtn).addClass("disabled hidden");
        $el.addClass("disabled");
    }

    /* image with checkboxes */
    handleImageWithCheckboxes(e, $el) {
        e.preventDefault();

        const elms = this.elms;
        const $question = $el.parents(elms.questionItem);
        const isAnswered = $question.hasClass("quiz-answered");
        const roomId = this.roomId;
        const currentStatus = getRoomStatus(roomId);
        const isRoomCompleted = currentStatus === "is-status-completed";

        if (isAnswered || isRoomCompleted) return false;

        $el.toggleClass("selected");

        const totalSelected = $el
            .parents(".checkboxing")
            .find("ul li.selected");

        if (totalSelected.length > 0) {
            $(elms.checkBtn).removeClass("disabled hidden");
        } else {
            $(elms.checkBtn).addClass("disabled hidden");
        }
    }

    onCheckAnswer(e, $el) {
        e.preventDefault();

        const is_leader = isLeader();
        if (!is_leader) return;

        const roomId = this.roomId;
        const currentStatus = getRoomStatus(roomId);
        const updatedStatus = "is-status-started";
        if (currentStatus === "is-status-completed") return false;

        const elms = this.elms;
        const $theQuestion = $(`${elms.questionItem}.active`);
        const questionType = $theQuestion.attr("data-type");
        const questionId = $theQuestion.attr("data-id");
        let playerAnswer;

        let roomScore = getRoomScore(roomId);
        const roomAnswers = getRoomAnswerById(roomId);
        const questionAnswer = roomAnswers?.[questionId] || {};
        let correctAudio, incorrectAudio;

        if (Object.keys(questionAnswer).length == 0) return false;

        const { correct_audio, incorrect_audio } = this._data;

        if (correct_audio) {
            correctAudio = document.createElement("audio");
            correctAudio.setAttribute("src", correct_audio);
            correctAudio.pause();
        }

        if (incorrect_audio) {
            incorrectAudio = document.createElement("audio");
            incorrectAudio.setAttribute("src", incorrect_audio);
            incorrectAudio.pause();
        }

        const onSuccessUpdate = () => {
            // this.maybeRoomIsFinish.call(this);
        };

        const onErrorUpdate = () => {};

        this.meSubmitting = true;

        /* multiple questions */
        if (questionType == "multiple_questions") {
            const $selectedAnswer = $theQuestion.find(
                `${elms.selectAnswer}.selected`,
            );
            const answerId = $selectedAnswer.attr("data-id");
            const $crystalEarned = $selectedAnswer.find(elms.crystalEarned);
            let audio = incorrectAudio;
            let answerStatus = "wrong";
            let correctScore = 0;

            const { answer, points } = questionAnswer;

            // validate player answer
            if (answerId == answer) {
                answerStatus = "correct";
                audio = correctAudio;

                correctScore = points;
                setRoomTotalScores(roomId, roomScore + Number(points));
            } else {
                $theQuestion
                    .find(`${elms.selectAnswer}[data-id="${answer}"]`)
                    .addClass("correct");
            }

            const pointsTxt =
                correctScore > 0 ? `+${correctScore}` : correctScore;
            $crystalEarned.text(pointsTxt).fadeIn();

            $selectedAnswer.addClass(answerStatus);
            $(elms.puzzlePartOneScreen)
                .find(".endgame-part-bg")
                .addClass(answerStatus);

            if (audio !== undefined) audio.play();

            const updatedData = {
                [questionId]: {
                    answer: answerId,
                    status: answerStatus,
                },
            };

            updateFinalRoomAnswer(roomId, updatedData)
                .then(onSuccessUpdate)
                .catch(onErrorUpdate);
            /* end multiple questions */

            /* image in order */
        } else if (questionType == "image_in_order") {
            playerAnswer = [];
            const $theImages = $theQuestion.find(elms.imageToOrder);
            const $crystalEarned = $theQuestion.find(elms.crystalEarned);
            let correct = 0;
            let wrong = 0;

            const { answer, points } = questionAnswer;

            // validate player answer
            $.each($theImages, function (index, item) {
                const dataOrder = parseInt($(item).attr("data-order")) || 0;
                const correctAnswer = answer[dataOrder - 1];
                const theAnswer = $(item).attr("data-id");
                let answerStatus = "wrong";

                if (correctAnswer == theAnswer) {
                    correct++;
                    $(item).addClass("correct");
                    answerStatus = "correct";
                } else {
                    wrong++;
                    $(item).addClass("wrong");
                }

                playerAnswer.push({
                    answer: theAnswer,
                    status: answerStatus,
                });
            });

            const isAllCorrect = wrong === 0 && correct > 0;
            const audio = isAllCorrect ? correctAudio : incorrectAudio;
            const answerStatus = isAllCorrect ? "correct" : "wrong";

            roomScore = isAllCorrect ? roomScore + Number(points) : 0;
            if (isAllCorrect) setRoomTotalScores(roomId, roomScore);

            const pointsTxt = isAllCorrect
                ? Number(points) > 0
                    ? `+${points}`
                    : points
                : 0;
            $crystalEarned.text(pointsTxt).fadeIn();

            this.clickCount = 0;

            $(elms.puzzlePartOneScreen)
                .find(".endgame-part-bg")
                .addClass(answerStatus);

            if (audio !== undefined) audio.play();

            const updatedData = {
                [questionId]: playerAnswer,
            };

            updateFinalRoomAnswer(roomId, updatedData)
                .then(onSuccessUpdate)
                .catch(onErrorUpdate);
            /* end image in order */

            /* image with checkboxes */
        } else if (questionType == "image_with_checkboxes") {
            playerAnswer = [];
            const $checkboxes = $theQuestion.find(`${elms.checkBox}.selected`);
            const $crystalEarned = $theQuestion.find(elms.crystalEarned);
            let correct = 0;
            let wrong = 0;

            const { answer, points } = questionAnswer;

            // validate player answer
            $.each($checkboxes, function (index, item) {
                const answerId = $(item).attr("data-id");
                const isCorrect = answer.includes(answerId);
                let answerStatus = "wrong";

                if (isCorrect) {
                    correct++;
                    $(item).addClass("correct");
                    answerStatus = "correct";
                } else {
                    wrong++;
                    $(item).addClass("wrong");
                }

                playerAnswer.push({
                    answer: answerId,
                    status: answerStatus,
                });
            });

            const isAllCorrect = wrong === 0 && correct > 0;
            const audio = isAllCorrect ? correctAudio : incorrectAudio;
            const answerStatus = isAllCorrect ? "correct" : "wrong";

            roomScore = isAllCorrect ? roomScore + Number(points) : 0;
            if (isAllCorrect) setRoomTotalScores(roomId, roomScore);

            const pointsTxt = isAllCorrect
                ? Number(points) > 0
                    ? `+${points}`
                    : points
                : 0;
            $crystalEarned.text(pointsTxt).fadeIn();

            $(elms.puzzlePartOneScreen)
                .find(".endgame-part-bg")
                .addClass(answerStatus);

            if (audio !== undefined) audio.play();

            if (!isAllCorrect) {
                $.each(answer, function (index, item) {
                    const $theCheckbox = $theQuestion.find(
                        `${elms.checkBox}[data-id="${item}"]`,
                    );

                    if (!$theCheckbox.hasClass("selected")) {
                        $theCheckbox.addClass("feedback-correct");
                    }
                });
            }

            const updatedData = {
                [questionId]: playerAnswer,
            };

            updateFinalRoomAnswer(roomId, updatedData)
                .then(onSuccessUpdate)
                .catch(onErrorUpdate);
            /* end image with checkboxes */

            /* image with input fields */
        } else if (questionType == "image_with_input_fields") {
            playerAnswer = {};
            const $inputs = $theQuestion.find(elms.inputAnswer);
            const $crystalEarned = $theQuestion.find(elms.crystalEarned);
            let correct = 0;
            let wrong = 0;

            const { answer, points } = questionAnswer;

            $.each($inputs, function (index, item) {
                const answerId = $(item).attr("data-id");
                const answerValue = $(item).val();
                const correctAnswer = answer?.[answerId];
                let answerStatus = "wrong";

                if (correctAnswer == answerValue) {
                    correct++;
                    $(item).addClass("correct");
                    answerStatus = "correct";
                } else {
                    wrong++;
                    $(item).addClass("wrong");
                }

                playerAnswer[answerId] = {
                    answer: answerValue,
                    status: answerStatus,
                };
            });

            const isAllCorrect = wrong === 0 && correct > 0;
            const audio = isAllCorrect ? correctAudio : incorrectAudio;
            const answerStatus = isAllCorrect ? "correct" : "wrong";

            roomScore = isAllCorrect ? roomScore + Number(points) : 0;
            if (isAllCorrect) setRoomTotalScores(roomId, roomScore);

            const pointsTxt = isAllCorrect
                ? Number(points) > 0
                    ? `+${points}`
                    : points
                : 0;
            $crystalEarned.text(pointsTxt).fadeIn();

            $(elms.puzzlePartOneScreen)
                .find(".endgame-part-bg")
                .addClass(answerStatus);

            if (audio !== undefined) audio.play();

            const updatedData = {
                [questionId]: playerAnswer,
            };

            updateFinalRoomAnswer(roomId, updatedData)
                .then(onSuccessUpdate)
                .catch(onErrorUpdate);
        }
        /* end image with input fields */

        $theQuestion.addClass("quiz-answered");
        $el.addClass("disabled hidden");
        $(elms.continueBtn).removeClass("disabled hidden");
        maybeUpdateRoomStatus(roomId, updatedStatus);
    }

    maybeRoomIsFinish() {
        const roomId = this.roomId;

        getFinalRoomAnswers(roomId).then((data) => {
            const roomAnswers = getRoomAnswerById(roomId);
            const fbRoomAnswers = data.val();

            if (
                !fbRoomAnswers ||
                typeof roomAnswers !== "object" ||
                typeof fbRoomAnswers !== "object"
            ) {
                return;
            }

            if (
                Object.keys(roomAnswers).length ==
                Object.keys(fbRoomAnswers).length
            ) {
                maybeUpdateRoomStatus(roomId, "is-status-completed");
            }
        });
    }

    playOutroVideo() {
        const $outroVideo = $(".videobox");
        const outroVideoUrl = this._data.video_block.video_outro;
        const is_leader = isLeader();

        if (is_leader) updateCurrentScreen(this.roomId, "video-outro");

        if (!$outroVideo.length) {
            this.goToRewardScreen();
            return false;
        }

        let states = Storage.get("states", {});
        let outroStates = states?.outroVideo || [];

        /**
         * check wheiter the video has url or not
         * if no url, close video popup and start room timer
         **/
        if (outroVideoUrl === "false") {
            this.goToRewardScreen();
            return false;
        }

        if (!outroStates.includes(this.roomId)) {
            // init video js with full screen
            const outroVideo = videojs("outro-video-end-game", {
                controls: true,
                autoplay: true,
                preload: "auto",
                sources: [
                    {
                        src: outroVideoUrl,
                        type: "video/mp4",
                    },
                ],
                techOrder: ["html5"],
            });

            // handle on ended video
            outroVideo.on("ended", () => {
                outroVideo.dispose();
                this.afterPlayOutroVideo();
            });

            // handle on error video
            outroVideo.on("error", function () {
                console.error("Can't play the video");
            });

            $outroVideo.addClass("is-open");

            try {
                outroVideo.play().catch((error) => {
                    // Autoplay was blocked. Do something
                    console.error("Unable to start auto play", error);
                });
            } catch (error) {
                console.error(error);
            }
        } else {
            this.goToRewardScreen();
        }
    }

    skipOutroVideo() {
        const videos = videojs.getPlayers();
        const outroVideo = videos["outro-video-end-game"];
        
        outroVideo.dispose();
        this.afterPlayOutroVideo();
    }

    afterPlayOutroVideo() {
        const $outroVideo = $(".videobox");
        let states = Storage.get("states", {});
        let outroStates = states?.outroVideo || [];

        if (!outroStates.includes(this.roomId)) {
            outroStates.push(this.roomId);
            states.outroVideo = outroStates;
            Storage.set("states", states);
        }

        $outroVideo.removeClass("is-open");
        this.goToRewardScreen();
    }

    /* show feedback reward screen */
    goToRewardScreen() {
        const elms = this.elms;
        const roomId = this.roomId;
        const rewards = this._data.rewards || [];
        const roomScore = getRoomScore(roomId);
        const $rewardPopup = $(elms.rewardScreen);
        const teamname = CONFIG.game.teamname;
        const is_leader = isLeader();
        const $outroVideo = $(".videobox");
        const $completionPopUp = $(".js-room-completion");

        // @ts-ignore
        const reward = rewards.find((item) => roomScore == Number(item.points));

        let title, subtitle, description;

        if (reward?.title) {
            title = reward.title;
            title = title.replaceAll("{team_name}", teamname);
        }

        if (reward?.subtitle) subtitle = reward.subtitle;

        if (reward?.description) description = reward.description;

        $outroVideo.removeClass("is-open");
        $completionPopUp.removeClass("is-open");

        $rewardPopup.addClass("active");
        $rewardPopup.find(elms.rewardTitle).text(title);
        $rewardPopup.find(elms.rewardSubtitle).text(subtitle);
        $rewardPopup.find(elms.rewardDescription).html(description);
        $rewardPopup.find(elms.rewardScore).text(roomScore);

        if (is_leader) updateCurrentScreen(roomId, "reward-screen");

        // hide timer hint popup
        $(".js-popup-timerhint").removeClass("is-open");
    }

    /* show customization screen */
    goToCustomizationScreen() {
        const elms = this.elms;
        const roomId = this.roomId;
        const roomScore = getRoomScore(roomId);
        const $rewardPopup = $(elms.rewardScreen);
        const $customizationPopup = $(elms.customizationScreen);
        const $score = $(elms.rewardScore);
        const $categories = $(elms.customizationCategory);
        const is_leader = isLeader();

        // @ts-ignore
        $categories.sort(function (a, b) {
            // @ts-ignore
            return $(b).attr("data-score") - $(a).attr("data-score");
        });

        $(elms.customizationCategory).each(function () {
            const $slider = $(this).find(".challange-prize__item-wrapper");
            const isInitialized = $slider.hasClass("slick-initialized");
            const sliderCustomRewardOption = {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                dots: false,
                arrows: true,
                prevArrow: $(this).find(`.challange-prize__item-prev`),
                nextArrow: $(this).find(`.challange-prize__item-next`),
            };

            if (!isInitialized) $slider.slick(sliderCustomRewardOption);
        });

        $.each($categories, function (index, item) {
            const $this = $(item);
            const theScore = Number($this.attr("data-score"));

            if (roomScore >= theScore) {
                $this.addClass("is-selected");
                return false;
            }
        });

        $rewardPopup.removeClass("active");
        $customizationPopup.addClass("active");
        $score.text(roomScore);

        if (is_leader) updateCurrentScreen(roomId, "customisations-screen");
    }

    setSelectedLogo() {
        const elms = this.elms;
        const roomId = this.roomId;
        const is_leader = isLeader();
        const roomLogo = getRoomLogo(roomId);
        const $selectedCategory = $(`
            ${elms.customizationCategory}.is-selected
        `);
        const $activeSlide = $selectedCategory.find(".slick-active");
        const $theImg = $activeSlide.find(elms.logoImage);
        const selectedImg = $theImg.attr("data-image");

        // redirect player to mainroom
        const goToMainroom = () => {
            const mainRoomID = CONFIG?.game?.rooms.find(
                (key) => key.id == roomId,
            ).mainroom_id;

            if (is_leader) updateCurrentScreen(roomId, null);
            GameLogic.goToPage(mainRoomID);
        };

        if (selectedImg == undefined) {
            goToMainroom();
            return false;
        }

        const onSuccessUpdate = () => {
            this.finishGame.call(this);
        };

        if (roomLogo || is_leader) {
            setTeamLogos(roomId, selectedImg)
                .then(onSuccessUpdate)
                .catch(goToMainroom);
        } else {
            goToMainroom();
        }
    }

    async finishGame() {
        const roomId = this.roomId;
        const gameProgress = getState().gameProgress;
        const rooms = CONFIG.game.rooms;
        const leaderId = getLeader();
        let totalCrystals = 0;
        let team_dashboard = [];

        rooms.forEach((room) => {
            const roomID = room.id;
            /* get silicon crystals (currency) */
            const roomScore = getRoomScore(roomID);
            totalCrystals = totalCrystals + Number(roomScore);

            /* get team dashboard customization */
            const logoCustomization = getRoomLogo(roomID);
            if (logoCustomization) {
                team_dashboard = {
                    ...team_dashboard,
                    [roomID]: logoCustomization,
                };
            }
        });

        if (gameProgress.allRoomCompleted) {
            await bdjs.goAsync(
                bdapi.post("game/finish-game", {
                    middle_state: getState().gameProgress.isMiddleState ? 1 : 0,
                    score: totalCrystals,
                    team_dashboard: team_dashboard,
                    leader: leaderId,
                }),
            );

            setGameFinished();
        } else {
            const mainRoomID = CONFIG?.game?.rooms.find(
                (key) => key.id == roomId,
            ).mainroom_id;

            updateCurrentScreen(roomId, null);
            GameLogic.goToPage(mainRoomID);
        }
    }

    setupSlider() {
        const sliderSourcePopup = {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: true,
            customPaging: function (slider, i) {
                return "<a>" + (i + 1) + "</a>";
            },
            appendDots: $(".source-popup__nav-item.nav-pagination"),
            prevArrow: $(".source-popup__nav-item.nav-left"),
            nextArrow: $(".source-popup__nav-item.nav-right"),
        };

        const sliderInfoPopup = {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: true,
            customPaging: function (slider, i) {
                return "<a>" + (i + 1) + "</a>";
            },
            appendDots: $(".msn-popup__nav-item.nav-pagination"),
            prevArrow: $(".msn-popup__nav-item.nav-left"),
            nextArrow: $(".msn-popup__nav-item.nav-right"),
        };

        const sliderInfoPopupPartTwo = {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: true,
            customPaging: function (slider, i) {
                return "<a>" + (i + 1) + "</a>";
            },
            appendDots: $(".msn-popup__nav-item-2.nav-pagination.part-two"),
            prevArrow: $(".msn-popup__nav-item.nav-left.part-two"),
            nextArrow: $(".msn-popup__nav-item.nav-right.part-two"),
        };
        $(".js-source-wrapper").slick(sliderSourcePopup);
        $(".js-info-slider-wrapper").slick(sliderInfoPopup);
        $(".js-info-part-two-slider-wrapper").slick(sliderInfoPopupPartTwo);
        $(".js-source-wrapper").slick("setPosition");
        $(".js-info-slider-wrapper").slick("setPosition");
    }

    closeNarrativePopup() {
        const elms = this.elms;
        const $narrativePopup = $(elms.narrativePopup);
        const isPopupAfterPhishing = $narrativePopup.hasClass(
            "js-popup-after-phishing",
        );

        GameLogic.toggleNarrative();

        if (isPopupAfterPhishing) {
            const $introPopupPartTwo = $(".js-info-popup-part-two");
            $introPopupPartTwo.addClass("active");
            $(".js-info-part-two-slider-wrapper").slick("slickGoTo", 0);
        }
    }
}
